import BaseService from '@/services/BaseService'
import {http} from './config'
class PedidoCompraService extends BaseService {
    constructor(){
        super('/v1/pedidos-compras')
    }

    listar(data){
        // const queryParams = `id=${data.id ? data.id : ''}
        // &fornecedor=${data.fornecedor ? data.fornecedor : ''}
        // &data=${data.data ? data.data : ''}
        // &limit=${data.limit ? data.limit : ''}
        // &page=${data.page ? data.page : 1}
        // `

        return http.get(`/v1/pedidos-compras`, {params: data})
    }

    imprimir(id){
        return http.get(`/v1/pedido-compra/${id}/imprimir`)
    }

    enviarEmail(data){
        return http.post(`/v1/pedido-compra/enviar/email`, data)
    }

}
export default new PedidoCompraService